import { Award } from "lucide-react";

function Slot({ title, w, sub, testid }) {
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid={testid}>
      {w ? <img src={w.portrait} alt={w.wolf_name} className="w-14 h-14 rounded-xl object-cover border border-amber-300/70 nft-glow" onError={(ev) => { ev.currentTarget.src = "/art/frost.webp"; }} />
        : <div className="w-14 h-14 rounded-xl border border-dashed border-slate-700" />}
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-[0.25em] font-mono-game text-slate-400">{title}</p>
        <p className="font-display text-xl text-white truncate" data-testid={`${testid}-name`}>{w ? w.wolf_name : "Up for grabs"}</p>
        <p className="text-xs text-slate-500">{sub}</p>
      </div>
    </div>
  );
}

export const MwpBanner = ({ mwp }) => (
  <section className="mb-10 rounded-3xl border border-amber-400/50 bg-gradient-to-br from-[#1a1405] via-[#0b1a20] to-[#061016] p-6 sm:p-8" data-testid="mwp-banner">
    <div className="flex items-center gap-3 mb-6">
      <Award className="w-7 h-7 text-amber-300" />
      <div>
        <p className="font-display text-2xl text-amber-100">MWP · Most Wolf Player</p>
        <p className="text-xs text-slate-400">Clear the most regions in a week to be crowned the week's MWP.</p>
      </div>
    </div>
    <div className="grid sm:grid-cols-2 gap-6">
      <Slot testid="mwp-last" title={mwp.last ? `Reigning MWP · ${mwp.last.week}` : "Reigning MWP"} w={mwp.last} sub={mwp.last ? "Crowned last week" : "The first MWP is crowned this Monday"} />
      <Slot testid="mwp-leader" title="Leading the MWP race" w={mwp.leader} sub={mwp.leader ? `${mwp.leader.regions_this_week} regions this week` : "No regions cleared yet this week"} />
    </div>
  </section>
);
